export default __webpack_public_path__ + "static/media/img/engr.nelvin-logo.webp";